module.exports = __webpack_public_path__ + "img/pr_5.1e276652.png";